import React from 'react';

import AspectRatio from 'components/AspectRatio';
import Video from 'components/Video';

interface VimeoProps {
  value: string;
}

const Vimeo: React.FCWithChildren<VimeoProps> = ({ value }) => {
  return (
    <AspectRatio aspectRatio={9 / 16}>
      <Video controls id={value} />
    </AspectRatio>
  );
};

export default Vimeo;
